import React, { useState } from 'react';
import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter, BsYoutube } from 'react-icons/bs';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';


const Hadear1 = () => {
    const [ismobile, setIsmobile] = useState(0);
    return (
        <>


            {/* <div className="preloader" style={{ display:"" }}>
                <div className="loading-container">
                    <div className="loading" />
                    <div id="loading-icon"><img src="./assets/cnd_1.png" alt /></div>
                </div>
            </div> */}

            {/* <header className="top-header py-2">
                <div className="container">
                    <div className="row align-content-center">
                        <div className="col-xl-3 col-lg-4 col-md-12 text-start top-btn">
                            <Link to="/Admission">
                                <button type="button" className="btn theme-orange">Admission & Fees</button></Link>
                            <Link to="/Contact">
                                <button type="button" className="btn theme-orange">Quick Inquery</button></Link>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 py-2 fw-bold f-15 announcement">
                            <i className="fa fa-bullhorn me-3" />
                            <span>Announcement</span>
                        </div>
                        <div className="col-xl-7 col-lg-5 col-md-8">
                            <p className="marquee">
                                <span> Admission Open for New Session 2026-27 in Sudarshan Public Hr. Sec. School with the best facilities.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </header> */}
            <nav className="navbar navbar-expand-lg sticky-top">
                <div className="container">
                    <Link className="navbar-brand">
                        <div className="logo-wrapper" style={{ marginBottom: "-39px" }}>
                            <Link className='d-flex justify-content-center align-items-center' to="/">
                                <img style={{ marginTop: "-60px" }} src="assets/img/cnd_logo_1.webp" className="img-fluid" alt="Edusquad" />
                            </Link>
                        </div>
                    </Link>
                    <div className={ismobile ? "moblink" : "desklink"} onClick={() => setIsmobile(false)} style={{marginRight:"90px"}}>
                        <ul>
                            <Link className=" text-decoration-none" to="/">
                                <li >Home</li>
                            </Link>
                            <Link className=" text-decoration-none" target="_blank" to="https://www.indiapost.gov.in/">
                                <li className='li' >Track Order</li>
                            </Link>
                            <Link className=" text-decoration-none" to="/about-us">
                                <li className='li' >About Us</li>
                            </Link>

                            <Link className=" text-decoration-none" to="/gallery">
                                <li> Our Gallery</li>
                            </Link>


                            <Link className=" text-decoration-none" to="/contact-us">
                                <li> Contact Us</li>
                            </Link>


                            {/* <Link className=" text-decoration-none" to="/">
                                <li> CEO Message</li>
                            </Link> */}


                        </ul>
                    </div>

                    <button className='vavbutn' onClick={() => setIsmobile(!ismobile)} style={{ marginBottom: "60px" }}>
                        {ismobile ? < IoMdClose /> : < GiHamburgerMenu />}
                    </button>
                </div>
            </nav>
        </>
    )
}
export default Hadear1